<template>
  <div>
    <p>Once configured:</p>
    <ul>
      <li><strong>Send a test message</strong> through one of your endpoints</li>
      <li><strong>Check this capability card</strong> - it will automatically update when messages are detected</li>
      <li><strong>View the All Messages tab</strong> to see your processed messages</li>
    </ul>
    <p>If messages still don't appear after a few minutes, check your endpoint logs and ServiceControl logs for any errors.</p>
  </div>
</template>
